module.exports = require("react-title-component");


/*****************
 ** WEBPACK FOOTER
 ** external "react-title-component"
 ** module id = 11
 ** module chunks = 0
 **/